import { Phone, Video, AlertCircle } from "lucide-react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const AUDIO_CONSULTATION_PRICE = 1250;
export const VIDEO_CONSULTATION_PRICE = 2250;
export const WHATSAPP_PHONE = "919108818369";

export const consultationTypes = [
  {
    id: "audio", title: "Voice Call Consultation", subtitle: "with Nadiya",
    price: AUDIO_CONSULTATION_PRICE, duration: "30 mins", icon: Phone,
    description: "One-on-one voice call consultation with Nadiya to discuss your health goals, nutrition plan, and wellness journey.",
    notes: ["Includes detailed report analysis", "Reports to be shared 1 day prior to consultation"]
  },
  {
    id: "video", title: "Video Call Consultation", subtitle: "with Nadiya",
    price: VIDEO_CONSULTATION_PRICE, duration: "30 mins", icon: Video, popular: true,
    description: "Face-to-face video call consultation with Nadiya for a comprehensive discussion, visual assessment, and personalized guidance.",
    notes: ["Includes detailed report analysis", "Reports to be shared 1 day prior to consultation"]
  }
];

export const SLOTS = ["5:00 PM - 5:30 PM", "5:30 PM - 6:00 PM", "6:00 PM - 6:30 PM", "6:30 PM - 7:00 PM"];
export const MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const STEP_LABELS = ["Type", "Details", "Schedule", "Payment"];

export function getMonthDays(year, month) {
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  return { firstDay, daysInMonth };
}

export function formatDate(date) {
  if (!date) return "";
  return `${DAY_NAMES[date.getDay()]}, ${date.getDate()} ${MONTH_NAMES[date.getMonth()]} ${date.getFullYear()}`;
}

export function toISODate(date) {
  if (!date) return "";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) { resolve(true); return; }
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

export function getStepClassName(currentStep, stepIndex) {
  if (currentStep > stepIndex + 1) return "bg-emerald_deep text-bone";
  if (currentStep === stepIndex + 1) return "border-2 border-emerald_deep text-emerald_deep";
  return "border border-border_custom text-text_muted/50";
}

export function getDayClassName(selected, disabled, sunday) {
  if (selected) return "bg-accent text-bone font-semibold";
  if (disabled) return "text-text_muted/20 cursor-not-allowed";
  const base = "text-emerald_deep hover:bg-accent/15 cursor-pointer";
  return sunday ? "text-red-400/30" : base;
}
